export enum CashFlowDirection {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}
